/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_After_3Inputs */

const en_landing_after_3 = /** @type {(inputs: Landing_After_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tailored application in under 2 minutes`)
};

const de_landing_after_3 = /** @type {(inputs: Landing_After_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angepasste Bewerbung in unter 2 Minuten`)
};

const fr_landing_after_3 = /** @type {(inputs: Landing_After_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Candidature sur mesure en moins de 2 minutes`)
};

const es_landing_after_3 = /** @type {(inputs: Landing_After_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitud personalizada en menos de 2 minutos`)
};

const it_landing_after_3 = /** @type {(inputs: Landing_After_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Candidatura personalizzata in meno di 2 minuti`)
};

const nl_landing_after_3 = /** @type {(inputs: Landing_After_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sollicitatie op maat in minder dan 2 minuten`)
};

const pl_landing_after_3 = /** @type {(inputs: Landing_After_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dopasowana aplikacja w mniej niż 2 minuty`)
};

const fi_landing_after_3 = /** @type {(inputs: Landing_After_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Räätälöity hakemus alle 2 minuutissa`)
};

const da_landing_after_3 = /** @type {(inputs: Landing_After_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skræddersyet ansøgning på under 2 minutter`)
};

const sv_landing_after_3 = /** @type {(inputs: Landing_After_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skräddarsydd ansökan på under 2 minuter`)
};

/**
* | output |
* | --- |
* | "Tailored application in under 2 minutes" |
*
* @param {Landing_After_3Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_after_3 = /** @type {((inputs?: Landing_After_3Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_After_3Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_after_3(inputs)
	if (locale === "fr") return fr_landing_after_3(inputs)
	if (locale === "es") return es_landing_after_3(inputs)
	if (locale === "it") return it_landing_after_3(inputs)
	if (locale === "nl") return nl_landing_after_3(inputs)
	if (locale === "pl") return pl_landing_after_3(inputs)
	if (locale === "fi") return fi_landing_after_3(inputs)
	if (locale === "da") return da_landing_after_3(inputs)
	if (locale === "sv") return sv_landing_after_3(inputs)
	return en_landing_after_3(inputs)
});